<template>
    <div
        class="marketing-leads-award"
        :style="componentStyle"
    >
        <div v-if="loading" class="loading-mask">
            <span :class="{ loading: loading }"></span>
        </div>
        <WxOpenBrowserMask v-model="isShowMask" />
        <MarketingInviterInfo
            v-if="showInviter"
            :account="inviterInfo"
            :textStyle="textStyle"
            :invitationText = "invitationText"
            class="inviter-container"
        />
        <MarketingAwardForm
            ref="awardForm"
            v-show="showForm"
            v-model="formData"
            :textStyle="textStyle"
            :campaignCode="pageConfig.campaignSourceCode"
            :fields="fields"
            @inputFocus="handleInputFocus"
            @inputBlur="handleInputBlur"
            @track="handleTrack"
            class="form-container"
        />
        <MarketingAwardButton
            :isLoading.sync="isLoading"
            :status="buttonStatus"
            :buttonImage="buttonImage"
            @action="handleClick"
            class="button-container"
        />
        <MarketingAwardLocation
            v-if="showLocation"
            ref="awardLocation"
            :isInit="isInit"
            :userPosition.sync="userPosition"
            :isInitLocation.sync="isInitLocation"
            :isInitializedLocation.sync="isInitializedLocation"
            :distanceValid="distanceValid"
            :locationType="locationType"
            :coordinates="coordinates"
            :coordinatesName="coordinatesName"
            :textColor="textColor"
            class="location-container"
        />
        <NioDialog
            :visible="isShowReceiveAwardsDialog"
            :title="receiveAwardsDlgSetting.title"
            :content="receiveAwardsDlgSetting.desc"
            :confirmText="receiveAwardsDlgSetting.btnText"
            cancelText="关闭"
            cancelClass="radius"
            confirmClass="radius"
            @confirm="jumpTo(awardPageLink)"
            @cancel="handleCloseDialog"
        >
            <template slot="content" class="receive-awards-dialog">
                <img
                    v-if="receiveAwardsDlgSetting.img"
                    :src="receiveAwardsDlgSetting.img"
                    class="receive-awards-dialog-img"
                    @error="handleImageError"
                />
                <div class="receive-awards-dialog-desc">
                    {{ receiveAwardsDlgSetting.desc }}
                </div>
            </template>
        </NioDialog>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import { getErrorMsg } from './result-code';
  import { isInNioCNApp, redirectToViewBridge } from '@/util/platform/universal';
  import { isWx } from '@/util/report/nioapp-event-report/utils';
  import { pushHash } from '@/util/dmp/push-hash';
  import NioDialog from '@/marketing_components/common/nio-dialog'; // @/components/common/nio-dialog
  import trackExposeMixin from '../../mixin/track-expose';
  import WxOpenBrowserMask from '../wx-open-browser-mask';
  import MarketingAwardButton from './award-button';
  import MarketingAwardLocation from './award-location';
  import MarketingAwardForm from './award-form';
  import MarketingInviterInfo from './inviter-info';
  const {
      awardIssueStatus,
      awardLocationStatus,
      awardButtonStatus,
      issueDialogTitle
} = require('./helpers');
import { PAGE_MODE_MAP } from '@/config/enums';
import { getLocation } from '@/util/platform';

  const mixin = {
      methods: {
          ...mapActions('marketing/', [
              'getAwardCompConfig',
              'issueAwardAfterLeads'
          ])
      },
      computed: {
          ...mapState('marketing/', [
              'campaignOption',
              'pageConfig',
              'getAccountData'
          ])
      }
  };

  export default {
      components: {
          NioDialog,
          WxOpenBrowserMask,
          MarketingAwardButton,
          MarketingAwardLocation,
          MarketingAwardForm,
          MarketingInviterInfo
      },
      mixins: [mixin, trackExposeMixin],
      props: {
          index: Number,
          rootMark: String,
          customStyle: {
              type: String,
              default: 'margin-top: 0; margin-bottom: 0'
          },
          backgroundSetting: {
              type: Object,
              default: () => ({
                  backgroundType: 'color',
                  background: '#fff'
              })
          },
          buttonImage: Object,
          awardPageLink: String,
          textColor: {
              type: String,
              default: '#050B27'
          },
          textStyle: Object,
          placeholderColor: {
              type: String,
              default: '#999DAE'
          },
          distanceValid: [String, Number],
          locationType: Array,
          coordinates: String,
          coordinatesName: String,
          isDemo: Boolean,
          formMode: {
              type: String,
              value: 'leads'
          },
          componentId: [String, Number],
          positionRank: [String, Number],
          trackName: String,
          invitationText: String,
          locationSwitch: {
              type: Boolean,
              default: true
          },
          fields: {
              type: Array,
              default: () => []
          },
          lpConfig: Object
      },
      data() {
          return {
              // 状态
              isInit: false,
              isInitLocation: false,
              isInitializedLocation: false, // 是否已初始化定位
              isLoading: false,
              isShowMask: false,
              isShowReceiveAwardsDialog: false,
              issueStatus: awardIssueStatus.PENDING,
              // 组件配置
              awardCompConfig: {
                  appHomePage: '', // app首页
                  downloadMiddlePage: '', // 下载中间页
                  loginPage: '' // 登录页
              },
              // 用户位置信息
              userPosition: {
                  distance: undefined,
                  lat: undefined,
                  lng: undefined,
                  cityName: undefined // 埋点用
              },
              // 弹框
              receiveAwardsDlgSetting: {
                  title: '领取成功',
                  btnText: '查看奖励',
                  desc: '恭喜获得打卡奖励',
                  img: ''
              },
              formData: {
                  country_code: '86', // 区号
                  mobile: '', // 手机号
                  verification_code: '', // 验证码
                  fellow_mobile: ''
              }
          };
      },
      computed: {
          loading() {
              return this.isLoading || this.isInit || this.isInitLocation;
          },
          distance() {
              return this.userPosition.distance;
          },
          locationStatus() {
              if (!this.locationSwitch) {
                  return awardLocationStatus.FULFILLED;
              }
              // 定位未初始化时
              if (!this.isInitializedLocation) {
                  return awardLocationStatus.UNINITIALIZED;
              }
              if (this.isInitLocation) {
                  return awardLocationStatus.PENDING;
              }
              if (
                  this.distance === undefined ||
                  this.distance > this.distanceValid
              ) {
                  return awardLocationStatus.REJECTED;
              }
              return awardLocationStatus.FULFILLED;
          },
          showForm() {
              return this.issueStatus === awardIssueStatus.PENDING;
          },
          showInviter() {
              return this.getAccountData.user;
          },
          showLocation() {
              return this.locationSwitch;
          },
          buttonStatus() {
              if (this.locationStatus === awardLocationStatus.UNINITIALIZED) {
                  return awardButtonStatus.PENDING;
              }
              if (this.locationStatus !== awardLocationStatus.FULFILLED) {
                  return awardButtonStatus.REJECTED;
              }
              if (this.issueStatus === awardIssueStatus.FULFILLED) {
                  return awardButtonStatus.FULFILLED;
              }
              return awardButtonStatus.PENDING;
          },
          componentStyle() {
              const { backgroundType, background } = this.backgroundSetting;
              if (backgroundType === 'img') {
                  const backgroundObj = this.imgBgStyle(background);
                  return `${this
                      .customStyle};background:${backgroundObj.background}`;
              }
              if (backgroundType === 'color') {
                  return `${this.customStyle};background:${background}`;
              }
              return {};
          },
          imgBgStyle() {
              return url => {
                  if (url) {
                      return {
                          background: `center / cover no-repeat url(${url})`
                      };
                  }
                  return { background: '#fff' };
              };
          },
          inviterInfo() {
              return this.getAccountData || {};
          }
      },
      mounted() {
          this.init();
      },
      methods: {
          async init() {
              this.isInit = true;
              try {
                  await this.checkConfig(); // 页面配置 apollo-config
              } catch (e) {
                  console.error('leads award init error', e);
              } finally {
                  this.isInit = false;
              }
          },
          async checkConfig() {
              try {
                  const awardCompConfigDetail = await this.getAwardCompConfig();
                  if (awardCompConfigDetail) {
                      this.awardCompConfig = awardCompConfigDetail.data;
                  }
              } catch (e) {
                  console.error('checkConfig error', e);
              }
          },
          async handleClick(type, target) {
              if (type === 'toHash') {
                  this.jumpTo(target);
                  return;
              }

              if (this.buttonStatus === awardButtonStatus.PENDING) {
                  this.trackRetentionFlow({
                      step_name: 'select_component'
                  });
                  this.issueAwards();
                  return;
              }
              if (this.buttonStatus === awardButtonStatus.FULFILLED) {
                  this.jumpTo(this.awardPageLink);
                  return;
              }
          },
          jumpTo(href) {
              if (!href) {
                  return;
              }

              if (!href.startsWith('http') && isWx()) {
                  pushHash(
                      encodeURIComponent(
                          JSON.stringify({
                              jump: 'immediate',
                              index: this.index,
                              from: this.rootMark,
                              target: href || ''
                          })
                      )
                  );
                  this.isShowMask = true;
                  return;
              }

              this.trackRetentionFlow({
                  step_name: 'select_component',
                  click_url: href
              });

              if (!href.startsWith('http') && isInNioCNApp()) {
                  redirectToViewBridge(href);
              } else {
                  location.href = href;
                  if (!href.startsWith('http') && !isInNioCNApp()) {
                      const { downloadMiddlePage } = this.awardCompConfig || {};

                      setTimeout(() => {
                          if (downloadMiddlePage) {
                              window.location.href = downloadMiddlePage;
                          }
                      }, 3000);
                  }
              }
          },
          getCreateLeadsParams() {
              const id = this.lpConfig.lpId;
              const token = this.lpConfig.lpToken;
              const params = {
                  lpid: `${id}_${token}`,
                  latitude: this.userPosition.lat,
                  longitude: this.userPosition.lng,
                  campaign_code: this.pageConfig.campaignSourceCode,
                  car_type: this.pageConfig.presetModel,
                  unique_key: this.campaignOption.uniqueKey,
                  mobile: this.formData.mobile,
                  verification_code: this.formData.verification_code,
                  country_code: this.formData.country_code,
                  fellow_emp_domain: this.campaignOption.fellowEmpDomain,
                  register_emp_domain: this.campaignOption.registerEmpDomain,
              };
  
              // fellow归属优先级：表单fellow手机号 > fellow_emp_domain > fellow_id (bff处理)
              if (this.formData.fellow_mobile) {
                  params.fellow_mobile = this.formData.fellow_mobile;
              } else if (this.campaignOption.fellowId) {
                  params.fellow_id = this.campaignOption.fellowId;
              }

              return params;
          },
          validateForm(dataOnly = false) {
              if (!this.$refs.awardForm) {
                  return false;
              }
              const validateFormResult = this.$refs.awardForm.checkForm();
              if (!validateFormResult) {
                  return false;
              }
              if (dataOnly) {
                  return true;
              }
              // 距离限制开关开时：经纬度必填
              if (
                  this.locationSwitch &&
                  (!this.userPosition.lat || !this.userPosition.lng)
              ) {
                  return false;
              }
              return true;
          },
          async issueAwards() {
              if (this.isDemo) {
                  this.mockIssueAwardSuccess();
                  return;
              }
              try {
                  if (!this.validateForm(true)) {
                      return;
                  }
                  // 获取位置信息
                  if (this.locationSwitch) {
                      if (this.$refs.awardLocation) {
                          await this.$refs.awardLocation.getLocation();
                      } else {
                          this.$message('未获取到当前位置信息，请重试');
                          return;
                      }
                  } else {
                      try {
                          const res = await getLocation();
                          const position = res || {};
                          this.userPosition = {
                              lat: position.lat,
                              lng: position.lng
                          };
                      } catch (e) {
                          console.error('Locate Failed: ', e);
                          this.userPosition = {
                              lat: undefined,
                              lng: undefined
                          };
                      }
                  }
                  if (!this.validateForm()) {
                      return;
                  }
                  if (this.locationStatus !== awardLocationStatus.FULFILLED) {
                      return;
                  }
                  this.isLoading = true;
                  const params = this.getCreateLeadsParams();
                  this.trackRetentionFlow({
                      step_name: 'begin',
                      tj_component: this.trackName
                  });
                  const result = await this.issueAwardAfterLeads(params);
                  if (result.result_code !== 'success') {
                      throw result;
                  }
                  this.doAfterIssueAwardSuccess(result.data);
              } catch (e) {
                  console.error('issueAwards error', e);
                  const msg = getErrorMsg(e.result_code, e);
                  this.$message(msg || '奖励领取失败，请稍后重试');
                  this.trackRetentionFlow({
                      step_name: 'getmessage_success',
                      is_success: false,
                      failure_reason: e.result_code,
                      failure_message: msg || e.debug_msg
                  });
              } finally {
                  this.isLoading = false;
              }
          },
          mockIssueAwardSuccess() {
              this.issueStatus = awardIssueStatus.FULFILLED;
              this.receiveAwardsDlgSetting = {
                  title: '提示',
                  btnText: '查看奖励',
                  desc: '预览状态下暂不支持奖励领取'
              };
              this.isShowReceiveAwardsDialog = true;
          },
          doAfterIssueAwardSuccess(res) {
              this.trackRetentionFlow({
                  step_name: 'getmessage_success',
                  is_success: true,
                  nio_user_id: res.user_id || res.userId // 兼容字段，20240321之后可以只支持user_id
              });
              this.issueStatus = awardIssueStatus.FULFILLED;
              this.receiveAwardsDlgSetting = {
                  title: issueDialogTitle[res.status] || '领取成功',
                  btnText: '查看奖励',
                  desc: res.message,
                  img: res.img
              };
              this.isShowReceiveAwardsDialog = true;
          },
          handleImageError(e) {
              e.target.src = '';
          },
          handleCloseDialog() {
              this.isShowReceiveAwardsDialog = false;
          },
          handleTrack(step_name) {
              this.trackRetentionFlow({ step_name });
          },
          trackRetentionFlow(custom = {}) {
              if (this.isDemo) {
                  return;
              }
              this.$tracker.collectPlus('RetentionFlow', {
                  requirement_id: 1435,
                  track_sign: 'aCar.b1013.c1799.d1809.result.RetentionFlow',
                  lp_id: this.lpConfig.lpId,
                  campaign_code: this.pageConfig.campaignSourceCode,
                  invite_account: this.campaignOption.accountId,
                  car_model: this.pageConfig.presetModel.toUpperCase(),
                  city: this.userPosition.cityName, // @TODO: app定位和wx定位没有
                  page: PAGE_MODE_MAP[this.formMode],
                  link: window.location.href,
                  component_id: this.componentId,
                  mkt_type: this.trackName,
                  position_rank: this.positionRank,
                  is_clickable: true,
                  fellow_emp_domain: this.campaignOption.fellowEmpDomain,
                  fellow_name: this.campaignOption.registerEmpDomain,
                  ...custom
              });
          },
          handleInputFocus(el) {
              this.$emit('inputFocus', this.rootMark, el);
          },
          handleInputBlur() {
              this.$emit('inputBlur', this.rootMark);
          }
      }
  };
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.marketing-leads-award {
    width: 100%;
    background-color: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    .inviter-container{
        padding: 20 * @layout375 0;
    }

    .button-container {
        padding: 20 * @layout375 0;
    }

    .location-container {
        padding-bottom: 34 * @layout375;
    }

    .loading-mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.35);
        z-index: 10;
    }

    .loading {
        height: 30 * @layout375;
        width: 30 * @layout375;
        border-width: 3 * @layout375;
        border-style: solid;
        border-radius: 50%;
        border-color: rgba(255, 255, 255, 0.8) rgba(58, 60, 68, 0.5)
            rgba(58, 60, 68, 0.5);
        animation: rotate-right 1s linear infinite normal;
    }

    .receive-awards-dialog {
        .nio-dialog__header {
            margin-bottom: 20 * @layout375;
        }
        &-img {
            width: 80 * @layout375;
            display: block;
            margin: auto;
            margin-bottom: 20 * @layout375;
        }
        &-desc {
            font-size: 16 * @layout375;
            line-height: 24 * @layout375;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/leads-award/award.vue